import {useEffect} from 'react'



export function useDraggableNode(nodeRef) {
  useEffect(() => {
    const node = nodeRef.current
    if (!node) return

    function handleMouseDown(e) {
      let current = e.target
      while (current && current !== node) {
        if (current.dataset && current.dataset.draggable === 'false') {
          return
        }
        current = current.parentNode
      }

      e.preventDefault()

      // Get computed style
      const computedStyle = window.getComputedStyle(node)
      // Try to read left and top if not set, fallback to getBoundingClientRect
      let left = parseInt(computedStyle.left, 10)
      let top = parseInt(computedStyle.top, 10)

      // If left/top are not valid numbers, calculate from the bounding rect
      if (isNaN(left) || isNaN(top)) {
        const rect = node.getBoundingClientRect()
        left = rect.left
        top = rect.top
      }
      // Clear right and bottom so dragging is solely controlled by left and top
      node.style.right = 'auto'
      node.style.bottom = 'auto'
      // Ensure the element has explicit left and top in its inline style.
      node.style.left = left + 'px'
      node.style.top = top + 'px'

      const startX = e.clientX
      const startY = e.clientY

      function handleMouseMove(e) {
        const dx = e.clientX - startX
        const dy = e.clientY - startY
        node.style.left = left + dx + 'px'
        node.style.top = top + dy + 'px'
      }

      function handleMouseUp() {
        window.removeEventListener('mousemove', handleMouseMove)
      }

      window.addEventListener('mousemove', handleMouseMove)
      window.addEventListener('mouseup', handleMouseUp, {once: true})
      window.addEventListener('contextmenu', handleMouseUp, {once: true})
    }

    node.addEventListener('mousedown', handleMouseDown)
    return () => {
      node.removeEventListener('mousedown', handleMouseDown)
    }
  }, [nodeRef])
}